import { RECIPIENT } from '@/karehero-app/tell-us-once/intake/content';

export type CaredFor = {
  /** What the avatar carries. */
  initials: string;
  name: string;
  /** How they are related to the person using the app. */
  relationship: string;
};

/**
 * Who this account is caring for.
 *
 * Two of them, because one makes a switcher a list of one. A second person is
 * the case the app is built around and never shows: the care does not stop at
 * one parent, and everything under the bar — the actions, the profile, the
 * claims — belongs to whichever of them the bar is naming.
 */
export const CARED_FOR: CaredFor[] = [
  { initials: 'M', name: RECIPIENT, relationship: 'Your mother' },
  { initials: 'B', name: 'Brian', relationship: 'Your father' },
];

export const CIRCLE_SWITCHER = {
  title: 'Who you’re caring for',
  manage: 'Manage care circle',
  add: 'Add someone you care for',
};
